import { render, staticRenderFns } from "./QuoteBuilderOtherLabourComponent.vue?vue&type=template&id=9ca55a56&scoped=true"
import script from "./QuoteBuilderOtherLabourComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourComponent.vue?vue&type=style&index=0&id=9ca55a56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca55a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ca55a56')) {
      api.createRecord('9ca55a56', component.options)
    } else {
      api.reload('9ca55a56', component.options)
    }
    module.hot.accept("./QuoteBuilderOtherLabourComponent.vue?vue&type=template&id=9ca55a56&scoped=true", function () {
      api.rerender('9ca55a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderOtherLabour/QuoteBuilderOtherLabourComponent.vue"
export default component.exports